export const NEXT_BEST_TASK_NAMESPACE = 'jira-insights-nbt-spotlight-viewed';
